export const shortString = (
  string?: string,
  startSymbolsCount = 6,
  endSymbolsCount = 4,
): string => {
  return string === undefined
    ? ""
    : `${string.slice(0, startSymbolsCount)}...${string.slice(
        string.length - endSymbolsCount,
      )}`;
};
